export default __webpack_public_path__ + "static/profile_bg-cf41d385d61696b4228ae641785867a1.webp";